import { ligainicial } from "./rutainicial.js";

const ligabase = ligainicial + "2018/Lic/C"; 

export const licitaciones2018 = [
    {
        // CONVOCATORIA NUM# 021
            'numConvocatoria' : 'Convocatoria No. 021/2018.',
            'idConvocatoria' : 'Convocatoria21',
            'procedimientos' : [
        // Licitación N122
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N122-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 10 al 14 de diciembre de 2018.',
                    'descripcionProcedimiento' : 'Rehabilitación de Casa de Artesanías (Hidarte), ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }21/N122/N122.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }21/N122/JAN122.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }21/N122/APN122.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }21/N122/FAN122.pdf`,
                    },
                    ],
                },
        // Licitación N121
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N121-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 10 al 14 de diciembre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Centro Gerontológico Integral de San Felipe Orizatlán, ubicada en la localidad de Huextetitla, Municipio de San Felipe Orizatlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }21/N121/N121.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }21/N121/JAN121.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }21/N121/APN121.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }21/N121/FAN121.pdf`,
                    },
                    ],
                },
        // Licitación N120
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N120-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 10 al 14 de diciembre de 2018.',
                    'descripcionProcedimiento' : 'Rehabilitación de Casa de Día de Tlaxcoapan, ubicada en la localidad y Municipio de Tlaxcoapan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }21/N120/N120.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }21/N120/JAN120.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }21/N120/APN120.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }21/N120/FAN120.pdf`,
                    },
                    ],
                },
        // Licitación N119
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N119-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 10 al 14 de diciembre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Centro Gerontológico Integral de Zimapán, ubicada en la localidad y Municipio de Zimapán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }21/N119/N119.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }21/N119/JAN119.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }21/N119/APN119.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }21/N119/FAN119.pdf`,
                    },
                    ],
                },
        // Licitación N118
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N118-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 10 al 14 de diciembre de 2018.',
                    'descripcionProcedimiento' : 'Construcción del emisor de agua pluviales del Parque Industrial del Altiplano, ubicada en la localidad de Acopinalco (Acopinalco y Tepetates), Municipio de Apan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }21/N118/N118.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }21/N118/JAN118.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }21/N118/APN118.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }21/N118/FAN118.pdf`,
                    },
                    ],
                },
        // Licitación N117
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N117-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 10 al 14 de diciembre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de una pista de conducción vehicular para el Instituto de Formación Profesional (etapa 2), ubicada en la localidad de San José Palma Gorda, Municipio de Mineral de la Reforma, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }21/N117/N117.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }21/N117/JAN117.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }21/N117/APN117.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }21/N117/FAN117.pdf`,
                    },
                    ],
                },
        // Licitación N116
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N116-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 10 al 14 de diciembre de 2018.',
                    'descripcionProcedimiento' : 'Creación de la Unidad Especializada de Atención a Niñas, Niños y Adolescentes, ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }21/N116/N116.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }21/N116/JAN116.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }21/N116/APN116.pdf`,
                    },
                    ],
                },
        // Licitación N115
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N115-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 10 al 14 de diciembre de 2018.',
                    'descripcionProcedimiento' : 'Continuación y modernización de la línea de electrificación y el equipamiento eléctrico de la subestación del cárcamo de bombeo del sistema de riego Alto Tunititlan (etapa 11), ubicada en la localidad La Palma, Municipio de Tezontepec de Aldama, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }21/N115/N115.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }21/N115/JAN115.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }21/N115/APN115.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }21/N115/FAN115.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 020
            'numConvocatoria' : 'Convocatoria No. 020/2018.',
            'idConvocatoria' : 'Convocatoria20',
            'procedimientos' : [
        // Licitación N114
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N114-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 3 al 7 de diciembre de 2018.',
                    'descripcionProcedimiento' : 'Entubamiento de canal Elba (2a. Etapa), ubicado en la localidad de Progreso, Municipio de Progreso de Obregón, Estado de Hidalgo. (Segundo procedimiento).',
                    'urlAnexos' : `${ ligabase }20/N114/N114.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }20/N114/JAN114.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }20/N114/APN114.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }20/N114/FAN114.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 019
            'numConvocatoria' : 'Convocatoria No. 019/2018.',
            'idConvocatoria' : 'Convocatoria19',
            'procedimientos' : [
        // Licitación N113
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N113-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 26 al 30 de noviembre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de sala para la extracción de miel de abeja en la Localidad de Zacayahuatl, municipio de San Felipe Orizatlán; ubicada en la localidad de Zacayahuatl, Municipio de San Felipe Orizatlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }19/N113/N113.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }19/N113/JAN113.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }19/N113/APN113.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }19/N113/FAN113.pdf`,
                    },
                    ],
                },
        // Licitación N112
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N112-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 26 al 30 de noviembre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de sala para la extracción de miel de abeja en la localidad de Xalcuautla, municipio de Lolotla; ubicada en la localidad de Xalcuautla, Municipio de Lolotla, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }19/N112/N112.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }19/N112/JAN112.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }19/N112/APN112.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }19/N112/FAN112.pdf`,
                    },
                    ],
                },
        // Licitación N111
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N111-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 26 al 30 de noviembre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de sala para la extracción de miel de abeja en la localidad de La Cumbre de Muridores, municipio de San Bartolo Tutotepec; ubicada en la localidad de La Cumbre de Muridores, Municipio de San Bartolo Tutotepec, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }19/N111/N111.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }19/N111/JAN111.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }19/N111/APN111.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }19/N111/FAN111.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 018
            'numConvocatoria' : 'Convocatoria No. 018/2018.',
            'idConvocatoria' : 'Convocatoria18',
            'procedimientos' : [
        // Licitación N110
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N110-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 26 de noviembre al 7 de diciembre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de plataforma para línea de transmisión en alta tensión 230 KV y cuadro de maniobras en el Altiplano, ubicada en la localidad de Acopinalco (Acopinalco y Tepetates), Municipio de Apan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }18/N110/N110.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }18/N110/JAN110.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }18/N110/APN110.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }18/N110/FAN110.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 017
            'numConvocatoria' : 'Convocatoria No. 017/2018.',
            'idConvocatoria' : 'Convocatoria17',
            'procedimientos' : [
        // Licitación N109
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N109-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 19 al 26 de noviembre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Huejutla de Reyes, ubicada en varias localidades del Municipio de Huejutla de Reyes, Estado de Hidalgo. (Segundo Procedimiento)',
                    'urlAnexos' : `${ ligabase }17/N109/N109.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }17/N109/JAN109.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }17/N109/APN109.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }17/N109/FAN109.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 016
            'numConvocatoria' : 'Convocatoria No. 016/2018.',
            'idConvocatoria' : 'Convocatoria16',
            'procedimientos' : [
        // Licitación N108
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N108-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 12 al 16 de noviembre de 2018.',
                    'descripcionProcedimiento' : 'Entubamiento de canal Elba (2a. Etapa), ubicado en la localidad de Progreso, Municipio de Progreso de Obregón, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }16/N108/N108.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }16/N108/JAN108.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }16/N108/APN108.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }16/N108/FAN108.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 015
            'numConvocatoria' : 'Convocatoria No. 015/2018.',
            'idConvocatoria' : 'Convocatoria15',
            'procedimientos' : [
        // Licitación N107
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N107-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 30 de octubre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Pachuca de Soto, ubicada en varias localidades del Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }15/N107/N107.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }15/N107/JAN107.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }15/N107/APN107.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }15/N107/FAN107.pdf`,
                    },
                    ],
                },
        // Licitación N106
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N106-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 30 de octubre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Tolcayuca, ubicada en la localidad de Gral. Felipe Ángeles Municipio de Tolcayuca, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }15/N106/N106.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }15/N106/JAN106.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }15/N106/APN106.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }15/N106/FAN106.pdf`,
                    },
                    ],
                },
        // Licitación N105
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N105-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 30 de octubre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Tepeapulco, ubicada en varias localidades del Municipio de Tepeapulco, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }15/N105/N105.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }15/N105/JAN105.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }15/N105/APN105.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }15/N105/FAN105.pdf`,
                    },
                    ],
                },
        // Licitación N104
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N104-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 30 de octubre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Tecozautla, ubicada en la localidad y Municipio de Tecozautla, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }15/N104/N104.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }15/N104/JAN104.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }15/N104/APN104.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }15/N104/FAN104.pdf`,
                    },
                    ],
                },
        // Licitación N103
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N103-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 30 de octubre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Progreso de Obregón, ubicada en la localidad de Progreso, Municipio de Progreso de Obregón, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }15/N103/N103.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }15/N103/JAN103.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }15/N103/APN103.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }15/N103/FAN103.pdf`,
                    },
                    ],
                },
        // Licitación N102
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N102-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 30 de octubre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Pisaflores, ubicada en varias localidades del Municipio de Pisaflores, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }15/N102/N102.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }15/N102/JAN102.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }15/N102/APN102.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }15/N102/FAN102.pdf`,
                    },
                    ],
                },
        // Licitación N101
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N101-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 30 de octubre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Pacula, ubicada en varias localidades del Municipio de Pacula, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }15/N101/N101.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }15/N101/JAN101.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }15/N101/APN101.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }15/N101/FAN101.pdf`,
                    },
                    ],
                },
        // Licitación N100
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N100-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 30 de octubre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Nicolás Flores, ubicada en varias localidades del Municipio de Nicolás Flores, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }15/N100/N100.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }15/N100/JAN100.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }15/N100/APN100.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }15/N100/FAN100.pdf`,
                    },
                    ],
                },
        // Licitación N99
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N99-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 30 de octubre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Nopala de Villagrán, ubicada en la localidad de Nopala, Municipio de Nopala de Villagrán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }15/N99/N99.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }15/N99/JAN99.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }15/N99/APN99.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }15/N99/FAN99.pdf`,
                    },
                    ],
                },
        // Licitación N98
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N98-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 30 de octubre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Mineral del Chico, ubicada en varias localidades del Municipio de Mineral del Chico, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }15/N98/N98.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }15/N98/JAN98.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }15/N98/APN98.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }15/N98/FAN98.pdf`,
                    },
                    ],
                },
        // Licitación N97
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N97-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 29 de octubre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Mineral de la Reforma, ubicada en varias localidades del Municipio de Mineral de la Reforma, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }15/N97/N97.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }15/N97/JAN97.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }15/N97/APN97.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }15/N97/FAN97.pdf`,
                    },
                    ],
                },
        // Licitación N96
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N96-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 29 de octubre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Molango de Escamilla, ubicada en la localidad de Molango, Municipio de Molango de Escamilla, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }15/N96/N96.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }15/N96/JAN96.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }15/N96/APN96.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }15/N96/FAN96.pdf`,
                    },
                    ],
                },
        // Licitación N95
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N95-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 29 de octubre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Metztitlán, ubicada en varias localidades del Municipio de Metztitlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }15/N95/N95.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }15/N95/JAN95.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }15/N95/APN95.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }15/N95/FAN95.pdf`,
                    },
                    ],
                },
        // Licitación N94
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N94-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 29 de octubre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de La Misión, ubicada en varias localidades del Municipio de La Misión, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }15/N94/N94.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }15/N94/JAN94.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }15/N94/APN94.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }15/N94/FAN94.pdf`,
                    },
                    ],
                },
        // Licitación N93
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N93-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 29 de octubre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Jacala de Ledezma, ubicada en varias localidades del Municipio de Jacala de Ledezma, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }15/N93/N93.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }15/N93/JAN93.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }15/N93/APN93.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }15/N93/FAN93.pdf`,
                    },
                    ],
                },
        // Licitación N92
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N92-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 29 de octubre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Ixmiquilpan, ubicada en varias localidades del Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }15/N92/N92.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }15/N92/JAN92.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }15/N92/APN92.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }15/N92/FAN92.pdf`,
                    },
                    ],
                },
        // Licitación N91
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N91-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 26 de octubre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Huichapan, ubicada en varias localidades del Municipio de Huichapan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }15/N91/N91.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }15/N91/JAN91.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }15/N91/APN91.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }15/N91/FAN91.pdf`,
                    },
                    ],
                },
        // Licitación N90
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N90-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 26 de octubre  de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Epazoyucan, ubicada en la localidad y Municipio de Epazoyucan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }15/N90/N90.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }15/N90/JAN90.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }15/N90/APN90.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }15/N90/FAN90.pdf`,
                    },
                    ],
                },
        // Licitación N89
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N89-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 26 de octubre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Eloxochitlán, ubicada en la localidad y Municipio de Eloxochitlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }15/N89/N89.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }15/N89/JAN89.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }15/N89/APN89.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }15/N89/FAN89.pdf`,
                    },
                    ],
                },
        // Licitación N88
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N88-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 26 de octubre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Chapantongo, ubicada en varias localidades del Municipio de Chapantongo, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }15/N88/N88.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }15/N88/JAN88.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }15/N88/APN88.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }15/N88/FAN88.pdf`,
                    },
                    ],
                },
        // Licitación N87
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N87-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 26 de octubre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Atotonilco de Tula, ubicada en la localidad de Conejos, Municipio de Atotonilco de Tula, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }15/N87/N87.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }15/N87/JAN87.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }15/N87/APN87.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }15/N87/FAN87.pdf`,
                    },
                    ],
                },
        // Licitación N86
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N86-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 26 de octubre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Atitalaquia, ubicada en varias localidades del Municipio de Atitalaquia, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }15/N86/N86.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }15/N86/JAN86.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }15/N86/APN86.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }15/N86/FAN86.pdf`,
                    },
                    ],
                },
        // Licitación N85
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N85-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 26 de octubre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Agua Blanca de Iturbide, ubicada en varias localidades del Municipio de Agua Blanca de Iturbide, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }15/N85/N85.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }15/N85/JAN85.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }15/N85/APN85.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }15/N85/FAN85.pdf`,
                    },
                    ],
                },
        // Licitación N84
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N84-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 26 de octubre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Huasca de Ocampo, ubicada en la localidad y Municipio de Huasca de Ocampo, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }15/N84/N84.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }15/N84/JAN84.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }15/N84/APN84.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }15/N84/FAN84.pdf`,
                    },
                    ],
                },
        // Licitación N83
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N83-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 26 de octubre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Sanitarios con Biodigestores, en el municipio de Acaxochitlán, ubicada en varias localidades del Municipio de Acaxochitlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }15/N83/N83.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }15/N83/JAN83.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }15/N83/APN83.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }15/N83/FAN83.pdf`,
                    },
                    ],
                },
        // Licitación N82
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N82-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 26 de octubre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Acaxochitlán, ubicada en varias localidades del Municipio de Acaxochitlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }15/N82/N82.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }15/N82/JAN82.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }15/N82/APN82.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }15/N82/FAN82.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 014
            'numConvocatoria' : 'Convocatoria No. 014/2018.',
            'idConvocatoria' : 'Convocatoria14',
            'procedimientos' : [
        // Licitación N81
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N81-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 30 de octubre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Piso Firme, en el municipio de Tlanchinol, ubicada en varias localidades del Municipio de Tlanchinol, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }14/N81/N81.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }14/N81/JAN81.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }14/N81/APN81.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }14/N81/FAN81.pdf`,
                    },
                    ],
                },
        // Licitación N80
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N80-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 30 de octubre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Tlahuiltepa, ubicada en varias localidades del Municipio de Tlahuiltepa, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }14/N80/N80.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }14/N80/JAN80.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }14/N80/APN80.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }14/N80/FAN80.pdf`,
                    },
                    ],
                },
        // Licitación N79
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N79-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 30 de octubre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Piso Firme, en el municipio de Yahualica, ubicada varias localidades del municipio de Yahualica, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }14/N79/N79.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }14/N79/JAN79.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }14/N79/APN79.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }14/N79/FAN79.pdf`,
                    },
                    ],
                },
        // Licitación N78
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N78-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 30 de octubre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Yahualica, ubicada en varias localidades del Municipio de Yahualica, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }14/N78/N78.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }14/N78/JAN78.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }14/N78/APN78.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }14/N78/FAN78.pdf`,
                    },
                    ],
                },
        // Licitación N77
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N77-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 30 de octubre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Sanitarios con Biodigestores, en el municipio de Xochiatipan, ubicada en la localidad de Pachiquitla, Municipio de Xochiatipan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }14/N77/N77.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }14/N77/JAN77.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }14/N77/APN77.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }14/N77/FAN77.pdf`,
                    },
                    ],
                },
        // Licitación N76
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N76-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 30 de octubre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Xochiatipan, ubicada en varias localidades del Municipio de Xochiatipan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }14/N76/N76.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }14/N76/JAN76.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }14/N76/APN76.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }14/N76/FAN76.pdf`,
                    },
                    ],
                },
        // Licitación N75
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N75-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 30 de octubre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Sanitarios con Biodigestores, en el municipio de Tlanchinol, ubicada en varias localidades del Municipio de Tlanchinol, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }14/N75/N75.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }14/N75/JAN75.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }14/N75/APN75.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }14/N75/FAN75.pdf`,
                    },
                    ],
                },
        // Licitación N74
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N74-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 30 de octubre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Tlanchinol, ubicada en varias localidades del Municipio de Tlanchinol, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }14/N74/N74.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }14/N74/JAN74.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }14/N74/APN74.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }14/N74/FAN74.pdf`,
                    },
                    ],
                },
        // Licitación N73
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N73-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 30 de octubre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Tianguistengo, ubicada en varias localidades del Municipio de Tianguistengo, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }14/N73/N73.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }14/N73/JAN73.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }14/N73/APN73.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }14/N73/FAN73.pdf`,
                    },
                    ],
                },
        // Licitación N72
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N72-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 30 de octubre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Tezontepec de Aldama, ubicada en varias localidades del Municipio de Tezontepec de Aldama, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }14/N72/N72.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }14/N72/JAN72.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }14/N72/APN72.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }14/N72/FAN72.pdf`,
                    },
                    ],
                },
        // Licitación N71
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N71-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 29 de octubre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Tepehuacán de Guerrero, ubicada en varias localidades del Municipio de Tepehuacán de Guerrero, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }14/N71/N71.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }14/N71/JAN71.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }14/N71/APN71.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }14/N71/FAN71.pdf`,
                    },
                    ],
                },
        // Licitación N70
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N70-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 29 de octubre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Sanitarios con Biodigestores, en el municipio de Tenango de Doria, ubicada en varias localidades del Municipio de Tenango de Doria, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }14/N70/N70.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }14/N70/JAN70.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }14/N70/APN70.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }14/N70/FAN70.pdf`,
                    },
                    ],
                },
        // Licitación N69
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N69-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 29 de octubre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Tenango de Doria, ubicada en varias localidades del Municipio de Tenango de Doria, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }14/N69/N69.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }14/N69/JAN69.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }14/N69/APN69.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }14/N69/FAN69.pdf`,
                    },
                    ],
                },
        // Licitación N68
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N68-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 29 de octubre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Singuilucan, ubicada en la localidad y Municipio de Singuilucan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }14/N68/N68.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }14/N68/JAN68.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }14/N68/APN68.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }14/N68/FAN68.pdf`,
                    },
                    ],
                },
        // Licitación N67
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N67-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 29 de octubre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Piso Firme, en el municipio de San Felipe Orizatlán, ubicada en varias localidades del Municipio de San Felipe Orizatlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }14/N67/N67.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }14/N67/JAN67.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }14/N67/APN67.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }14/N67/FAN67.pdf`,
                    },
                    ],
                },
        // Licitación N66
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N66-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 29 de octubre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de San Felipe Orizatlán, ubicada en varias localidades del Municipio de San Felipe Orizatlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }14/N66/N66.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }14/N66/JAN66.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }14/N66/APN66.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }14/N66/FAN66.pdf`,
                    },
                    ],
                },
        // Licitación N65
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N65-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 29 de octubre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de San Bartolo Tutotepec, ubicada en varias localidades del Municipio de San Bartolo Tutotepec, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }14/N65/N65.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }14/N65/JAN65.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }14/N65/APN65.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }14/N65/FAN65.pdf`,
                    },
                    ],
                },
        // Licitación N64
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N64-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 29 de octubre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Sanitarios con Biodigestores, en el municipio de San Bartolo Tutotepec, ubicada en varias localidades del Municipio de San Bartolo Tutotepec, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }14/N64/N64.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }14/N64/JAN64.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }14/N64/APN64.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }14/N64/FAN64.pdf`,
                    },
                    ],
                },
        // Licitación N63
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N63-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 29 de octubre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Lolotla, ubicada en varias localidades del Municipio de Lolotla, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }14/N63/N63.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }14/N63/JAN63.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }14/N63/APN63.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }14/N63/FAN63.pdf`,
                    },
                    ],
                },
        // Licitación N62
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N62-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 29 de octubre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Jaltocán, ubicada en la localidad y Municipio de Jaltocán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }14/N62/N62.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }14/N62/JAN62.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }14/N62/APN62.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }14/N62/FAN62.pdf`,
                    },
                    ],
                },
        // Licitación N61
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N61-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 26 de octubre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Huejutla de Reyes, ubicada en varias localidades del Municipio de Huejutla de Reyes, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }14/N61/N61.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }14/N61/JAN61.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }14/N61/APN61.pdf`,
                    },
                    ],
                },
        // Licitación N60
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N60-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 26 de octubre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Sanitarios con Biodigestores, en el municipio de Huehuetla, ubicada en varias localidades del Municipio de Huehuetla, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }14/N60/N60.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }14/N60/JAN60.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }14/N60/APN60.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }14/N60/FAN60.pdf`,
                    },
                    ],
                },
        // Licitación N59
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N59-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 26 de octubre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Huehuetla, ubicada en varias localidades del Municipio de Huehuetla, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }14/N59/N59.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }14/N59/JAN59.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }14/N59/APN59.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }14/N59/FAN59.pdf`,
                    },
                    ],
                },
        // Licitación N58
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N58-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 26 de octubre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Huazalingo, ubicada en varias localidades del Municipio de Huazalingo, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }14/N58/N58.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }14/N58/JAN58.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }14/N58/APN58.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }14/N58/FAN58.pdf`,
                    },
                    ],
                },
        // Licitación N57
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N57-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 26 de octubre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Huautla, ubicada en varias localidades del Municipio de Huautla, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }14/N57/N57.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }14/N57/JAN57.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }14/N57/APN57.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }14/N57/FAN57.pdf`,
                    },
                    ],
                },
        // Licitación N56
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N56-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 26 de octubre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Francisco I. Madero, ubicada en varias localidades del Municipio de Francisco I. Madero, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }14/N56/N56.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }14/N56/JAN56.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }14/N56/APN56.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }14/N56/FAN56.pdf`,
                    },
                    ],
                },
        // Licitación N55
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N55-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 26 de octubre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Chapulhuacán, ubicada en la localidad de Iglesia Vieja, Municipio de Chapulhuacán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }14/N55/N55.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }14/N55/JAN55.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }14/N55/APN55.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }14/N55/FAN55.pdf`,
                    },
                    ],
                },
        // Licitación N54
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N54-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 26 de octubre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Calnali, ubicada en varias localidades del Municipio de Calnali, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }14/N54/N54.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }14/N54/JAN54.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }14/N54/APN54.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }14/N54/FAN54.pdf`,
                    },
                    ],
                },
        // Licitación N53
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N53-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 26 de octubre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Sanitarios con Biodigestores, en el municipio de Atlapexco, ubicada en varias localidades del Municipio de Atlapexco, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }14/N53/N53.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }14/N53/JAN53.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }14/N53/APN53.pdf`,
                    },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }14/N53/AMDAPN53.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }14/N53/FAN53.pdf`,
                    },
                    ],
                },
        // Licitación N52
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N52-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 26 de octubre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Atlapexco, ubicada en varias localidades del Municipio de Atlapexco, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }14/N52/N52.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }14/N52/JAN52.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }14/N52/APN52.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }14/N52/FAN52.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 013
            'numConvocatoria' : 'Convocatoria No. 013/2018.',
            'idConvocatoria' : 'Convocatoria13',
            'procedimientos' : [
        // Licitación N51
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N51-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 15 al 19 de octubre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Acaxochitlan, ubicada en varias localidades del Municipio de Acaxochitlán, Estado de Hidalgo. (Segundo procedimiento).',
                    'urlAnexos' : `${ ligabase }13/N51/N51.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }13/N51/JAN51.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }13/N51/APN51.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }13/N51/FAN51.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 012
            'numConvocatoria' : 'Convocatoria No. 012/2018.',
            'idConvocatoria' : 'Convocatoria12',
            'procedimientos' : [
        // Licitación N50
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N50-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 8 al 19 de octubre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Sanitarios con Biodigestores, en el municipio de Huehuetla, ubicada en varias localidades del Municipio de Huehuetla, Estado de Hidalgo. (Segundo procedimiento).',
                    'urlAnexos' : `${ ligabase }12/N50/N50.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }12/N50/JAN50.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }12/N50/APN50.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }12/N50/FAN50.pdf`,
                    },
                    ],
                },
        // Licitación N49
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N49-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 8 al 19 de octubre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Jacala de Ledezma, ubicada en varias localidades del Municipio de Jacala de Ledezma, Estado de Hidalgo. (Segundo procedimiento).',
                    'urlAnexos' : `${ ligabase }12/N49/N49.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }12/N49/JAN49.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }12/N49/APN49.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }12/N49/FAN49.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 011
            'numConvocatoria' : 'Convocatoria No. 011/2018.',
            'idConvocatoria' : 'Convocatoria11',
            'procedimientos' : [
        // Licitación N48
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N48-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 24 de septiembre al 5 de octubre de 2018.',
                    'descripcionProcedimiento' : 'Unidad de Servicios Estatales Tulancingo; ubicada en la localidad de Tulancingo, Municipio de Tulancingo de Bravo, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }11/N48/N48.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }11/N48/JAN48.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }11/N48/APN48.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }11/N48/FAN48.pdf`,
                    },
                    ],
                },
        // Licitación N47
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N47-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 24 de septiembre al 5 de octubre de 2018.',
                    'descripcionProcedimiento' : 'Electrificación del Consorcio de Innovación Textil y de Manufactura 4.0 para el Desarrollo de los Sectores Productivos del Estado de Hidalgo; ubicada en la localidad de Santa Catarina, Municipio de San Agustín Tlaxiaca, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }11/N47/N47.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }11/N47/JAN47.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }11/N47/APN47.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }11/N47/FAN47.pdf`,
                    },
                    ],
                },
        // Licitación N46
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N46-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 24 de septiembre al 5 de octubre de 2018.',
                    'descripcionProcedimiento' : 'Construcción del estacionamiento del Centro Nacional de Innovación y Moda de las Industrias Textil y del Vestido; ubicada en la localidad de Santa Catarina, Municipio de San Agustín Tlaxiaca, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }11/N46/N46.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }11/N46/JAN46.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }11/N46/APN46.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }11/N46/FAN46.pdf`,
                    },
                    ],
                },
        // Licitación N45
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N45-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 24 de septiembre al 5 de octubre de 2018.',
                    'descripcionProcedimiento' : 'Ampliación del Camino Rural E.C.F. (Pachuca - Tampico) Acatempa - San Salvador - Tianguis - Tlalnepango - Tehuetlán - Toctitlan - Tepeyac Tramo del km. 0+000 al km. 13+105 subtramo del km. 1+000 al km. 2+000; ubicada en varias localidades del Municipio de Tlanchinol, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }11/N45/N45.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }11/N45/JAN45.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }11/N45/APN45.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }11/N45/FAN45.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 010
            'numConvocatoria' : 'Convocatoria No. 010/2018.',
            'idConvocatoria' : 'Convocatoria10',
            'procedimientos' : [
        // Licitación N44
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N44-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 10 al 24 de septiembre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Sanitarios con Biodigestores, en el municipio de San Bartolo Tutotepec, ubicada en la localidad de La Vereda, Municipio de San Bartolo Tutotepec, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }10/N44/N44.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }10/N44/JAN44.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }10/N44/APN44.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }10/N44/FAN44.pdf`,
                    },
                    ],
                },
        // Licitación N43
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N43-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 10 al 24 de septiembre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Sanitarios con Biodigestores, en el municipio de Huehuetla, ubicada en varias localidades del Municipio de Huehuetla, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }10/N43/N43.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }10/N43/JAN43.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }10/N43/APN43.pdf`,
                    },
                    ],
                },
        // Licitación N42
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N42-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 10 al 24 de septiembre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de San Bartolo Tutotepec, ubicada en varias localidades del Municipio de San Bartolo Tutotepec, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }10/N42/N42.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }10/N42/JAN42.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }10/N42/APN42.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }10/N42/FAN42.pdf`,
                    },
                    ],
                },
        // Licitación N41
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N41-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 10 al 24 de septiembre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Sanitarios con Biodigestores, en el municipio de Pisaflores, ubicada en varias localidades del Municipio de Pisaflores, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }10/N41/N41.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }10/N41/JAN41.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }10/N41/APN41.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }10/N41/FAN41.pdf`,
                    },
                    ],
                },
        // Licitación N40
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N40-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 10 al 24 de septiembre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Sanitarios con Biodigestores, en el municipio de Agua Blanca de Iturbide, ubicada en varias localidades del Municipio de Agua Blanca de Iturbide, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }10/N40/N40.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }10/N40/JAN40.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }10/N40/APN40.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }10/N40/FAN40.pdf`,
                    },
                    ],
                },
        // Licitación N39
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N39-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 10 al 24 de septiembre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Sanitarios con Biodigestores, en el municipio de Acaxochitlan, ubicada en varias localidades del Municipio de Acaxochitlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }10/N39/N39.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }10/N39/JAN39.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }10/N39/APN39.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }10/N39/FAN39.pdf`,
                    },
                    ],
                },
        // Licitación N38
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N38-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 10 al 24 de septiembre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de cuartos dormitorio, en el municipio de Pisaflores, ubicada en varias localidades del Municipio de Pisaflores, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }10/N38/N38.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }10/N38/JAN38.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }10/N38/APN38.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }10/N38/FAN38.pdf`,
                    },
                    ],
                },
        // Licitación N37
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N37-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 10 al 24 de septiembre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Jacala de Ledezma, ubicada en varias localidades del Municipio de Jacala de Ledezma, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }10/N37/N37.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }10/N37/JAN37.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }10/N37/APN37.pdf`,
                    },
                    ],
                },
        // Licitación N36
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N36-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 10 al 24 de septiembre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Agua Blanca de Iturbide, ubicada en varias localidades del Municipio de Agua Blanca de Iturbide, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }10/N36/N36.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }10/N36/JAN36.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }10/N36/APN36.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }10/N36/FAN36.pdf`,
                    },
                    ],
                },
        // Licitación N35
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N35-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 10 al 24 de septiembre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Acaxochitlan, ubicada en varias localidades del Municipio de Acaxochitlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }10/N35/N35.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }10/N35/JAN35.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }10/N35/APN35.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }10/N35/FAN35.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 009
            'numConvocatoria' : 'Convocatoria No. 009/2018.',
            'idConvocatoria' : 'Convocatoria9',
            'procedimientos' : [
        // Licitación N34
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N34-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 10 al 21 de septiembre de 2018.',
                    'descripcionProcedimiento' : 'Rehabilitación de DIF Municipal; ubicada en la localidad y Municipio de Santiago de Anaya, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }9/N34/N34.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }9/N34/JAN34.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }9/N34/APN34.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }9/N34/FAN34.pdf`,
                    },
                    ],
                },
        // Licitación N33
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N33-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 10 al 21 de septiembre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de techumbre en Escuela Secundaria Técnica no. 46 "Quetzalcóatl", clave 13DST0048F; ubicada en la localidad de Gandho, Municipio de Tecozautla, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }9/N33/N33.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }9/N33/JAN33.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }9/N33/APN33.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }9/N33/FAN33.pdf`,
                    },
                    ],
                },
        // Licitación N32
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N32-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 10 al 21 de septiembre de 2018.',
                    'descripcionProcedimiento' : 'Reencarpetamiento de pavimentación asfáltica en acceso y calles de Pueblo Nuevo 2da. etapa, ubicada en la localidad de Pueblo Nuevo, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }9/N32/N32.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }9/N32/JAN32.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }9/N32/APN32.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }9/N32/FAN32.pdf`,
                    },
                    ],
                },
        // Licitación N31
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N31-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 10 al 21 de septiembre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de Carretera (libramiento) con asfalto; ubicada en la localidad y Municipio de Chapantongo, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }9/N31/N31.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }9/N31/JAN31.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }9/N31/APN31.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }9/N31/FAN31.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 008
            'numConvocatoria' : 'Convocatoria No. 008/2018.',
            'idConvocatoria' : 'Convocatoria8',
            'procedimientos' : [
        // Licitación N30
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N30-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 27 de agosto al 7 de septiembre de 2018.',
                    'descripcionProcedimiento' : 'Encarpetamiento de las Av. Corregidora y Avenida Morelos, ubicada en la localidad y Municipio de Emiliano Zapata, Estado de Hidalgo. (Segundo Procedimiento)',
                    'urlAnexos' : `${ ligabase }8/N30/N30.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }8/N30/JAN30.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }8/N30/APN30.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }8/N30/FAN30.pdf`,
                    },
                    ],
                },
        // Licitación N29
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N29-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 27 de agosto al 7 de septiembre de 2018.',
                    'descripcionProcedimiento' : 'Ampliación de espacio para sala de testigos y sala de empoderamiento en el Centro de Justicia para Mujeres Hidalguenses, ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo. (Segundo Procedimiento).',
                    'urlAnexos' : `${ ligabase }8/N29/N29.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }8/N29/JAN29.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }8/N29/APN29.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }8/N29/FAN29.pdf`,
                    },
                    ],
                },
        // Licitación N28
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N28-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 27 de agosto al 7 de septiembre de 2018.',
                    'descripcionProcedimiento' : 'Rehabilitación del Centro de Educación y Capacitación Ambiental Región Huasteca, ubicada en la localidad y Municipio de Huejutla de Reyes, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }8/N28/N28.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }8/N28/JAN28.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }8/N28/APN28.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }8/N28/FAN28.pdf`,
                    },
                    ],
                },
        // Licitación N27
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N27-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 27 de agosto al 7 de septiembre de 2018.',
                    'descripcionProcedimiento' : 'Unidad Especializada en el Combate al Secuestro 4ta. Etapa, ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }8/N27/N27.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }8/N27/JAN27.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }8/N27/APN27.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }8/N27/FAN27.pdf`,
                    },
                    ],
                },
        // Licitación N26
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N26-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 27 de agosto al 7 de septiembre de 2018.',
                    'descripcionProcedimiento' : 'Remodelación del Centro Asistencial Casa de la Tercera Edad del Sistema DIF Hidalgo, ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }8/N26/N26.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }8/N26/JAN26.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }8/N26/APN26.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }8/N26/FAN26.pdf`,
                    },
                    ],
                },
        // Licitación N25
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N25-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 27 de agosto al 7 de septiembre de 2018.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica El Templo - San Pedro, El Tephe, ubicada en la localidad de El Tephe, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }8/N25/N25.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }8/N25/JAN25.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }8/N25/APN25.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }8/N25/FAN25.pdf`,
                    },
                    ],
                },
        // Licitación N24
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N24-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 27 de agosto al 7 de septiembre de 2018.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica en Calle San Pedro, Los Ventura, ubicada en la localidad de El Tephe, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }8/N24/N24.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }8/N24/JAN24.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }8/N24/APN24.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }8/N24/FAN24.pdf`,
                    },
                    ],
                },
        // Licitación N23
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N23-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 27 de agosto al 7 de septiembre de 2018.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación hidráulica Crucero San Luis Buenavista - Vías del Tren Altepemila (primera etapa), ubicada en la localidad Altepemila, Municipio de Santiago Tulantepec de Lugo Guerrero, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }8/N23/N23.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }8/N23/JAN23.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }8/N23/APN23.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }8/N23/FAN23.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 007
            'numConvocatoria' : 'Convocatoria No. 007/2018.',
            'idConvocatoria' : 'Convocatoria7',
            'procedimientos' : [
        // Licitación N22
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N22-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 27 de agosto al 7 de septiembre de 2018.',
                    'descripcionProcedimiento' : 'Centro Regional de Desarrollo Infantil Otomí-Tepehua cimentación y estructura, ubicada en la localidad y Municipio de San Bartolo Tutotepec, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }7/N22/N22.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }7/N22/JAN22.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }7/N22/APN22.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }7/N22/FAN22.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 006
            'numConvocatoria' : 'Convocatoria No. 006/2018.',
            'idConvocatoria' : 'Convocatoria6',
            'procedimientos' : [
        // Licitación N21
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N21-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 13 al 24 de agosto de 2018.',
                    'descripcionProcedimiento' : 'Ampliación de estacionamiento con asfalto, caseta de vigilancia con exclusa y pluma para el cuartel de la Secretaría de Seguridad Pública, ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo. (Segundo procedimiento).',
                    'urlAnexos' : `${ ligabase }6/N21/N21.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }6/N21/JAN21.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }6/N21/APN21.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }6/N21/FAN21.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 005
            'numConvocatoria' : 'Convocatoria No. 005/2018.',
            'idConvocatoria' : 'Convocatoria5',
            'procedimientos' : [
        // Licitación N20
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N20-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 6 al 17 de agosto de 2018.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica en Calle Orquídea Manzana El Pirul en la Comunidad La Estancia, ubicada en la localidad de La Estancia, Municipio de Chilcuautla, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }5/N20/N20.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }5/N20/JAN20.pdf`,
                    },
                    ],
                },
        // Licitación N19
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N19-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 6 al 17 de agosto de 2018.',
                    'descripcionProcedimiento' : 'Encarpetamiento de las Av. Corregidora y Avenida Morelos, ubicada en la localidad y Municipio de Emiliano Zapata, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }5/N19/N19.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }5/N19/JAN19.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 004
            'numConvocatoria' : 'Convocatoria No. 004/2018.',
            'idConvocatoria' : 'Convocatoria4',
            'procedimientos' : [
        // Licitación N18
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N18-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de julio al 10 de agosto de 2018.',
                    'descripcionProcedimiento' : 'Construcción de gimnasio al aire libre, ubicado en la localidad de Fray Bernardino de Sahagún (Ciudad Sahagún), Municipio de Tepeapulco, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }4/N18/N18.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }4/N18/JAN18.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }4/N18/APN18.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }4/N18/FAN18.pdf`,
                    },
                    ],
                },
        // Licitación N17
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N17-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de julio al 10 de agosto de 2018.',
                    'descripcionProcedimiento' : 'Construcción de parque recreativo, ubicada en la localidad de Fray Bernardino de Sahagún (Ciudad Sahagún), Municipio de Tepeapulco, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }4/N17/N17.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }4/N17/JAN17.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }4/N17/APN17.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }4/N17/FAN17.pdf`,
                    },
                    ],
                },
        // Licitación N16
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N16-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de julio al 10 de agosto de 2018.',
                    'descripcionProcedimiento' : 'Ampliación de espacio para sala de testigos y sala de empoderamiento en el Centro de Justicia para Mujeres Hidalguenses, ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }4/N16/N16.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }4/N16/JAN16.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }4/N16/APN16.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }4/N16/FAN16.pdf`,
                    },
                    ],
                },
        // Licitación N15
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N15-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de julio al 10 de agosto de 2018.',
                    'descripcionProcedimiento' : 'Reconstrucción de carretera Capula -Cerritos Capula-Exhacienda Debodhe del Km 0+000 al 2+800 en tramos aislados, ubicada en varias localidades del Municipio de Ixmiquilpan, Estado de Hidalgo. (Segundo Procedimiento).',
                    'urlAnexos' : `${ ligabase }4/N15/N15.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }4/N15/JAN15.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }4/N15/APN15.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }4/N15/FAN15.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 003
            'numConvocatoria' : 'Convocatoria No. 003/2018.',
            'idConvocatoria' : 'Convocatoria3',
            'procedimientos' : [
        // Licitación N14
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N14-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 16 al 27 de julio de 2018.',
                    'descripcionProcedimiento' : 'Remodelación de Edificios del H. Congreso del Estado de Hidalgo, ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }3/N14/N14.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }3/N14/JAN14.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }3/N14/APN14.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }3/N14/FAN14.pdf`,
                    },
                    ],
                },
        // Licitación N13
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N13-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 16 al 27 de julio de 2018.',
                    'descripcionProcedimiento' : 'Ampliación de dormitorios, mejoramiento de áreas de gobierno, sentenciados, procesados, área perimetral acabados e instalaciones, ubicada en la localidad y Municipio de Tula de Allende, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }3/N13/N13.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }3/N13/JAN13.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }3/N13/APN13.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }3/N13/FAN13.pdf`,
                    },
                    ],
                },
        // Licitación N12
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N12-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 16 al 27 de julio de 2018.',
                    'descripcionProcedimiento' : 'Ampliación de estacionamiento con asfalto, caseta de vigilancia con exclusa y pluma para el cuartel de la Secretaría de Seguridad Pública, ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }3/N12/N12.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }3/N12/JAN12.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }3/N12/APN12.pdf`,
                    },
                    ],
                },
        // Licitación N11
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N11-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 16 al 27 de julio de 2018.',
                    'descripcionProcedimiento' : 'Construcción de una pista para prácticas de conducción vehicular para el Instituto de Formación Profesional, ubicada en la localidad de San José Palma Gorda, Municipio de Mineral de la Reforma, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }3/N11/N11.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }3/N11/JAN11.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }3/N11/APN11.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }3/N11/FAN11.pdf`,
                    },
                    ],
                },
        // Licitación N10
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N10-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 16 al 27 de julio de 2018.',
                    'descripcionProcedimiento' : 'Carpeta asfáltica C.M. Santa Rita-Santa Ana Batha, ubicada en la localidad de Santa Ana Batha, Municipio de Chilcuautla, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }3/N10/N10.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }3/N10/JAN10.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }3/N10/APN10.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }3/N10/FAN10.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 002
            'numConvocatoria' : 'Convocatoria No. 002/2018.',
            'idConvocatoria' : 'Convocatoria2',
            'procedimientos' : [
        // Licitación N9
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N9-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 25 de junio al 6 de julio de 2018.',
                    'descripcionProcedimiento' : 'Terminación de puente vehicular en Teocalco, ubicado en la localidad de Teocalco, Municipio de Tula de Allende, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }2/N9/N9.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }2/N9/JAN9.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }2/N9/APN9.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }2/N9/FAN9.pdf`,
                    },
                    ],
                },
        // Licitación N8
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N8-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 25 de junio al 6 de julio de 2018.',
                    'descripcionProcedimiento' : 'Pavimentación del camino de acceso a Xuchitlán-Mejay, tramo: troncal del Km 3+040 al Km 4+365.50, ubicada en la localidad de Xuchitlán, Municipio de San Salvador, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }2/N8/N8.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }2/N8/JAN8.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }2/N8/APN8.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }2/N8/FAN8.pdf`,
                    },
                    ],
                },
        // Licitación N7
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N7-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 25 de junio al 6 de julio de 2018.',
                    'descripcionProcedimiento' : 'Conservación de la red carretera estatal mediante la aplicación de riego de sello reforzado con fibra de vidrio 2018, Región: Tula, Tepeji del Río e Ixmiquilpan, de Cobertura Estatal.',
                    'urlAnexos' : `${ ligabase }2/N7/N7.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }2/N7/JAN7.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }2/N7/APN7.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }2/N7/FAN7.pdf`,
                    },
                    ],
                },
        // Licitación N6
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N6-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 25 de junio al 6 de julio de 2018.',
                    'descripcionProcedimiento' : 'Conservación de la red carretera estatal mediante la aplicación de riego de sello reforzado con fibra de vidrio 2018, Región: Pachuca, Tulancingo, Actopan, Otomí-Tepehua, Tizayuca, de Cobertura Estatal.',
                    'urlAnexos' : `${ ligabase }2/N6/N6.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }2/N6/JAN6.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }2/N6/APN6.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }2/N6/FAN6.pdf`,
                    },
                    ],
                },
        // Licitación N5
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N5-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 25 de junio al 6 de julio de 2018.',
                    'descripcionProcedimiento' : 'Reconstrucción C.E. San Pedro Tlaquilpan-La Trinidad, del Km. 0+000 al Km. 4+009.20, ubicada en la localidad de La Trinidad, Municipio de Zempoala, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }2/N5/N5.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }2/N5/JAN5.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }2/N5/APN5.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }2/N5/FAN5.pdf`,
                    },
                    ],
                },
        // Licitación N4
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N4-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 25 de junio al 6 de julio de 2018.',
                    'descripcionProcedimiento' : 'Reconstrucción de acceso a San Mateo Ixtlahuaca del Km. 0+000 al Km. 1+520, ubicada en la localidad de las Pintas, Municipio de Tolcayuca, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }2/N4/N4.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }2/N4/JAN4.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }2/N4/APN4.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }2/N4/FAN4.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 001
            'numConvocatoria' : 'Convocatoria No. 001/2018.',
            'idConvocatoria' : 'Convocatoria1',
            'procedimientos' : [
        // Licitación N3
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N3-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 25 de junio al 6 de julio de 2018.',
                    'descripcionProcedimiento' : 'Bardeado perimetral en Telesecundaria No. 197, ubicada en San Juan Solís; en la localidad de San Juan Solís, Municipio de San Agustín Tlaxiaca, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }1/N3/N3.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }1/N3/JAN3.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }1/N3/APN3.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }1/N3/FAN3.pdf`,
                    },
                    ],
                },
        // Licitación N2
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N2-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 25 de junio al 6 de julio de 2018.',
                    'descripcionProcedimiento' : 'Reconstrucción de carretera Capula -Cerritos Capula-Exhacienda Debodhe del Km 0+000 al 2+800 en tramos aislados, ubicada en varias localidades del Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }1/N2/N2.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }1/N2/JAN2.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }1/N2/APN2.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }1/N2/FAN2.pdf`,
                    },
                    ],
                },
        // Licitación N1
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N1-2018.',
                    'vigencia' : 'Vigencia de venta de bases: del 25 de junio al 6 de julio de 2018.',
                    'descripcionProcedimiento' : 'Reconstrucción de carpeta asfáltica del Libramiento al Hospital Regional del Altiplano, del Km. 0+000 al Km. 1+417.9, ubicada en la localidad y Municipio de Apan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }1/N1/N1.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }1/N1/JAN1.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }1/N1/APN1.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }1/N1/FAN1.pdf`,
                    },
                    ],
                },
            ],
    },   
] 